var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{staticClass:"error--text text-center mt-4"},[_vm._v(_vm._s(_vm.parent.$t('errors.correct_fields')))])}
var staticRenderFns = []

export { render, staticRenderFns }